(function () {
  function showToast(root, message) {
    var el = root.querySelector('[data-event-detail-toast]');
    if (!el || !message) return;
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(el._hideT);
    el._hideT = setTimeout(function () {
      el.classList.remove('is-visible');
    }, 2200);
  }

  function initSidebar(root) {
    var shareUrl = root.getAttribute('data-share-url') || window.location.href;

    var shareBtn = root.querySelector('[data-sidebar-share]');
    if (shareBtn && shareBtn.dataset.sidebarShareBound !== '1') {
      shareBtn.dataset.sidebarShareBound = '1';
      shareBtn.addEventListener('click', function () {
        if (navigator.share) {
          navigator
            .share({ url: shareUrl, title: document.title })
            .catch(function () {});
        } else if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(shareUrl).then(function () {
            var msg = shareBtn.getAttribute('data-toast-copied') || 'Copied';
            showToast(root, msg);
          });
        } else {
          window.prompt('', shareUrl);
        }
      });
    }
  }

  function initAll(scope) {
    var rootEl = scope && scope.nodeType === 1 ? scope : document;
    rootEl.querySelectorAll('[data-event-detail-sidebar]').forEach(initSidebar);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', function (e) {
    if (e && e.target && e.target.nodeType === 1) initAll(e.target);
  });
})();
